<script>
  import Login from './views/Login.svelte'
  import Downloads from './views/Downloads.svelte'

  let user = {
    isLoggedIn: false
  }

  $: headline = user.isLoggedIn ? 'Downloads' : 'Login'

  function onLogin({ detail }) {
    user = { ...detail, isLoggedIn: true }
  }

  function onLogout() {
    user = {
      isLoggedIn: false
    }
  }
</script>

<h1 class="main-headline">{headline}</h1>
{#if user && user.isLoggedIn}
  <section class="user-header">
    <p>Eingeloggt als: {user.name}</p>
    <button
      class="button--icon button--light button--text -logout"
      on:click={onLogout}>Logout</button
    >
  </section>
  <Downloads {user} />
{:else}
  <Login on:login={onLogin} />
{/if}

<style>
  .user-header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 1rem;
  }
</style>
